import Vue from 'vue'
import App from './App'
import store from './store.js'
import jQuery from 'jquery'
import router from './router.js'
import i18n from './i18n'
import vuetify from './plugins/vuetify';
import _ from 'lodash';
import VueSlimScroll from 'vue-slimscroll'

Object.defineProperty(Vue.prototype, '$_', { value: _ });
global.jQuery = jQuery
global.$ = jQuery

Vue.config.productionTip = false
Vue.use(VueSlimScroll);

var vm = new Vue({
    el: '#app',
    store,
    router,
    i18n,
    components: { App },
    vuetify,
    template: '<App/>'
})

const lang = store.state.country;
if (lang) {
    i18n.locale = lang
}


global.vm = vm